export default __webpack_public_path__ + "fe6c8dc5c2e1eb2d4f3dd12f5565286a.png";